import { type PID } from '@fs/zion-tree-types'
import { Row, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useParams } from '@fs/zion-router'
import SubHeader from './SubHeader'

export default function ContributionsActionBarSkeleton(): JSX.Element {
  const { relationshipId } = useParams() as {
    relationshipId?: PID
  }

  return (
    <Row alignY="middle" guttersX="sm">
      <SubHeader />

      <div growX />
      {!relationshipId && <Skeleton.Button emphasis="medium" minWidth={100} data-testid="filter-button-skeleton" />}
    </Row>
  )
}
